import React, { createContext, useContext, useState } from 'react';

const initialFormState = {
  // Step 1: Details
  rotaName: '',
  location: 'Sunset Restaurant',
  startDate: '2026-05-01',
  endDate: '2026-05-31',
  rotaType: 'Standard',
  workingPattern: '',
  notes: '',
  // Step 2: Staff Selection
  selectedStaffIds: [],
  // Step 5: Notifications
  notifyOnPublish: true,
  sendReminder: true,
  includeChecksInNotification: true,
  customMessage: '',
  // Step 6: Additional Settings
  allowSwap: true,
  requireApproval: true,
  lockAfterPublish: false,
};

const RotaContext = createContext(undefined);

export const RotaProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialFormState);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => setFormData(initialFormState);

  return (
    <RotaContext.Provider value={{ formData, updateField, resetForm }}>
      {children}
    </RotaContext.Provider>
  );
};

export const useRotaForm = () => {
  const context = useContext(RotaContext);
  if (!context) throw new Error('useRotaForm must be used within a RotaProvider');
  return context;
};
